<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content">
      <div>
        <div class="simkeropl">{{$t('Payment.Complete')}}</div>
        <div class="back_content" @click="bank"><img src="../../assets/shape(1).svg" alt=""> {{$t('Payment.Go_Back')}}</div>
        <div class="hr_content"></div>

        <!--购买套餐信息模块开始-->
        <div class="title_playus">{{Package.order_title}}</div>
        <ul>
            <li v-for="(item,index) in Package.order_details" :key="index">{{item}}</li>
        </ul>
        <div class="cla_jiage_ppl">{{Package.order_price_name}}</div>
        <div class="cimmmaa">{{Package.member_end_at}}</div>
        <!--购买套餐信息模块结束-->

        <!--个人信息模块开始-->
        <div class="hr_content"></div>
        <div class="classinde_tx">{{$t('Payment.Personal_Infomation')}}</div>
        <input class="su_omsernmn" v-model="last_student_nickname" type="text" placeholder="请输入姓名"/>
        <div class="diskm">
            <input class="dim_1" v-model="email" type="text" placeholder="请输入邮箱"/>
            <div class="dim_2"></div>
            <input class="dim_3" v-model="mobile" type="text" placeholder="请输入手机号" />
        </div>
        <div class="hr_content"></div>
        <!--个人信息模块结束-->

        <div class="hei_timaa">{{$t('Payment.Payment_Method')}}</div>

        <div class="sinmm_xz">
            <div class="sindaainmqs" @click="check(iten)" v-for="(iten,index) in check_list" :key="index">
              <img class="flin cur" v-if="checked != iten.id" src="../../assets/x1.svg" alt="">
              <img class="flin cur" v-if="checked == iten.id" src="../../assets/x2.svg" alt="">
              <div class="flin">{{iten.text}}</div>
              <img v-if="iten.id == 1" src="../../assets/z1.svg" alt="">
              <img v-if="iten.id == 1" src="../../assets/z2.svg" alt="">
              <img v-if="iten.id == 1" src="../../assets/z3.svg" alt="">
              <img v-if="iten.id == 1" src="../../assets/z4.svg" alt="">
              <img v-if="iten.id == 2" style="margin-top: 4px;" src="../../assets/z5.svg" alt="">
            </div>
        </div>

        <div class="sim_txtun" v-html="this.$t('Payment.describe')"></div>

        <div class="hr_content"></div>

        <div class="diskm">
            <div class="dim_1"><span class="cindkk">{{$t('pay_Success.Total')}}:</span><span class="sjiacum">{{Package.order_price}}</span></div>
            <div class="dim_2"></div>
            <div class="dim_3 sijdems" @click="go_play">{{$t('Payment.Pay_Now')}}</div>
        </div>


        <div class="dian mgb"></div>
      </div>
    </div>
  </el-main>

</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
          height:100,
          Package:[],
          check_list:[
            {
              text:'Credit Card',
              id:1
            },{
              text:'Alipay',
              id:2
            }],
          checked:1,
          handleResultNew: function (result) {
          if (result.error) {
            alert('failed')
          }
        },
        last_student_nickname:'',
        email:'',
        mobile:'',
        describe:null,
      }
    },
    created () {

      let height = document.body.offsetHeight-80;
      this.height = height;
            if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.last_student_nickname= getStore(keys.userProfile).name;
      this.email=getStore(keys.userProfile).email;
      this.mobile='+'+getStore(keys.userProfile).country_code+' '+getStore(keys.userProfile).mobile;

      this.Package = getStore(keys.Order_information);

    },
    methods: {
      bank(){
        this.$router.push({ path:'/home/children/PurchaseLessonPlan'})
      },
      check(e){
        this.checked = e.id
      },
      createCheckoutSession () {
        let that = this
        return new Promise((resolve, reject) => {
          that.$http.post('/api/stripePayment', {
            order_no: this.Package.order_no,
            // type: 'mobile',
            token: getStore(keys.token)
          }).then(res => {
            if(res.data.code == 200){
              resolve(res.data.data.sessionId)
              return res.data.data.sessionId
            }else{
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
            // resolve(res.data.sessionId)
            // return res.data.sessionId
          })
        })
      },
      go_play(item){
        let _this = this;
        this.$http.post('/api/confirmOrder', {
          order_no:this.Package.order_no,
          username:this.last_student_nickname,
          mobile:this.mobile,
          email:this.email,
          pay_method:this.checked
        }).then((res) => {
          if (res.data.code == 200) {
            _this.to_page();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 第三方支付方法调用
       */
      to_page(){
        var that = this
        if (!this.Package.order_no) {
          this.$message({
            message: this.$t('recharge.selectPackage'),
            type: 'warning'
          })
          return false
        }
        let ouder_id = this.Package.order_no
        this.utils.setCookies({setPayData: JSON.stringify(this.Package)})
        // var stripe = stripe('pk_test_51H2iOSLvUcRqAd8paHZmX26Fkazd889p8f7lw8kBXdsDDsosvXZf1GQNFdTrx2EcQxlHMQklcjL7ie3WfnTgjAgj00Y1lnu2NJ')
        var stripe = Stripe('pk_live_51H2iOSLvUcRqAd8piK4KqTRgmvlxgG1S7pMoER8Ike9oBpfOtVzEjzQWiErwW4kbxDOiQ9xkKETm60RXQcEXx108007VlSNnrR')//正式
        // var stripe = Stripe('pk_test_51H2iOSLvUcRqAd8paHZmX26Fkazd889p8f7lw8kBXdsDDsosvXZf1GQNFdTrx2EcQxlHMQklcjL7ie3WfnTgjAgj00Y1lnu2NJ')//测试
        this.createCheckoutSession(ouder_id).then(data => {
          stripe.redirectToCheckout({sessionId: data}).then(this.handleResultNew)
        })
      }
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>
.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    text-align: center;
    margin-bottom:48.41px;
}
.back_content{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height, or 100% */
    text-align: left;
    color: #4B69FE;
    cursor: pointer;
}
.hr_content{
    // width: 625px;
    height: 0px;
    border: 1px solid #E6E6E6;
    margin-top:26px;
}
.title_playus{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 22px;
    /* identical to box height, or 85% */
    color: #000000;
    margin-top:30px;
    margin-bottom:10px;
}
ul{
    margin-left: 22px;
}
li{
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 29px;
    /* or 181% */
    color: rgba(11, 29, 51, 0.6);
    list-style: outside;
}
.cla_jiage_ppl{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 19px;
    line-height: 18px;
    /* or 95% */
    text-align: right;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #000000;
}
.cimmmaa{
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 15px;
    /* identical to box height, or 107% */
    text-align: right;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #000000;
    margin-top:14px;
}
.classinde_tx{
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    color: #000000;
    margin-top:30px;
    margin-bottom:20px;
}
.su_omsernmn{
    width: 625px;
    height: 50px;
    border: 1px solid #CFCFCF;
    box-sizing: border-box;
    border-radius: 100px;
    margin-top:10px;
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 50px;
    /* identical to box height, or 89% */
    color: #000000;
    text-indent: 20px;
}
.diskm{
    display: flex;
    width:625px;
    margin-top:20px;
}
.dim_1{
    height: 50px;
    border:1px solid #CFCFCF;
    flex: 12;
    border-radius: 100px;
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 16px;
    /* identical to box height, or 89% */
    color: #000000;
    text-indent: 20px;
    line-height: 50px;
}
.dim_2{
    flex:1;
}
.dim_3{
    height: 50px;
    border:1px solid #CFCFCF;
    flex: 12;
    border-radius: 100px;
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 16px;
    /* identical to box height, or 89% */
    color: #000000;
    text-indent: 20px;
    line-height: 50px;
}
.hei_timaa{
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    color: #000000;
    margin-top:20px;
    margin-bottom:20px;
}
.sinmm_xz{
    width:625px;
}
.yuandian{
    width: 19px;
    height: 19px;
    background: rgba(196, 196, 196, 0.25);
    border: 1px solid #CFCFCF;
    box-sizing: border-box;
    border-radius: 100%;
    cursor: pointer;
    margin-bottom: 10px;
    margin-right:15px;
}
.tiztimn{
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */
    color: #0B1D33;
}
.sim_txtun{
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 16px;
    /* or 145% */
    margin-top:30px;
    color: #919191;
}
.sijdems{
    font-family: Poppins !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 50px !important;
    /* identical to box height */
    text-align: center !important;
    color: #FFFFFF !important;
    background: #4B69FE !important;
    cursor: pointer;
}
.active{
  background: #4B69FE !important;
}
.flin{
  float: left;
  margin-right: 15px;
}
.sindaainmqs{
  overflow: hidden;
}
.cur{
  cursor: pointer;
}
.col_text{
  color: #4B69FE;
  text-decoration:underline;
}
.cindkk{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  /* identical to box height, or 100% */
  color: #000000;
}
.sjiacum{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  // line-height: 22px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/children/CompletePayment.vue